import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--general-spacer-04, 1.5rem);
  width: 100%;
  height: 100%;
  padding-block: var(--general-spacer-04, 1.5rem);
  padding-inline: var(--general-spacer-04, 1.5rem);
  margin-inline: auto;
  /* Override global div.inverse / div[class*='color-scheme'] background rules. */
  && {
    background-color: var(--t-color-scrim-100, rgba(0, 0, 0, 0.54));
    background-image: none;
  }
`;

export const TextBlockWrapper = styled.div`
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
`;
